"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiTab = {
    styleOverrides: {
        root: {
            textTransform: 'none',
        },
    },
};
exports.default = muiTab;
//# sourceMappingURL=muiTab.js.map